// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37e01","comment":"styles_comment__3oVIa"};